var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgUnmerge = function SvgUnmerge(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M4.163 20.4 1.2 17.35l.85-.881 1.504 1.538v-5.984q0-.626.431-1.069a1.4 1.4 0 0 1 1.04-.443h4.644q.71 0 1.214-.52a1.73 1.73 0 0 0 .506-1.25V3.6l1.22.008V8.74q0 .73.504 1.25.505.52 1.215.52h4.645q.607 0 1.039.444.43.443.43 1.07v5.983l1.496-1.538.862.881-2.963 3.05-2.964-3.05.85-.881 1.5 1.538v-5.984a.25.25 0 0 0-.07-.185.24.24 0 0 0-.18-.072h-4.645q-.723 0-1.33-.328a2.9 2.9 0 0 1-1-.882q-.392.555-.999.882a2.76 2.76 0 0 1-1.33.328H5.024a.24.24 0 0 0-.18.072.25.25 0 0 0-.07.185v5.984l1.49-1.538.862.881z"
  })));
};
export default SvgUnmerge;